// extracted by mini-css-extract-plugin
export var aboutLink = "header-module--about-link--72721";
export var headerContainer = "header-module--header-container--00f10";
export var headerContainerCenter = "header-module--header-container-center--f0cc3";
export var headerLinkHome = "header-module--header-link-home--7e119";
export var headerLogo = "header-module--header-logo--c5580";
export var headerTitle = "header-module--header-title--5e2f5";